
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2350',
  depVersions: {
  "customer-portal-app": "static-1.2350",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9681",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25429",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5604",
  "hs-test-utils": "static-1.8026",
  "hub-http": "static-1.6234",
  "hub-http-shared-msw-handlers": "static-1.9999",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18275",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11484",
  "I18n": "static-7.1628",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6477",
  "payment-link-components": "static-1.23588",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7049",
  "quartz-core": "static-1.6268",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10219",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5353",
  "rich-text-lib": "static-1.19858",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18014",
  "ui-components-test-utils": "static-1.5621",
  "UIComponents": "static-3.8430",
  "foundations-assets": "static-1.4879",
  "foundations-components": "static-1.7963",
  "foundations-theming": "static-1.4431",
  "foundations-theming-specialty": "static-1.2147",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.911",
  "quartz-config": "static-1.827",
  "quartz-routing": "static-1.479",
  "quick-fetch": "static-1.3925",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16684",
  "rpc-client-utils": "static-1.4665",
  "sanitize-text": "static-1.8154",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4775",
  "ui-addon-react-router-dom": "static-1.9554",
  "usage-tracker": "static-1.7358",
  "usage-tracker-anonymous": "static-1.5775",
  "usage-tracker-core": "static-1.7208",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3407",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3326",
  "quartz-webpack": "static-1.3273",
  "bend-plugin-quartz-routing": "static-1.127",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7682",
  "frontend-preferences-client": "static-1.7940",
  "laboratory-lib": "static-3.7168",
  "onboarding-scopes": "static-1.6474",
  "seat-types-lib": "static-1.47",
  "ui-addon-opt": "static-4.8379",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3137",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.89",
  "ts-schema": "static-1.4088",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7772",
  "cssUtils": "static-1.794",
  "customer-data-ui-utilities": "static-1.9839",
  "HubStyle": "static-2.11791",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.724",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9900",
  "ui-addon-i18n": "static-1.11161",
  "ui-business-units-lib": "static-1.9067",
  "ui-shepherd-react": "static-3.10177",
  "video-components-external": "static-1.11328",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4340",
  "commerce-tours-lib": "static-1.6128",
  "customer-data-properties": "static-1.51606",
  "getting-started-shared-tasks": "static-1.18507",
  "growth-onboarding-reliability": "static-1.5095",
  "onboarding-tours": "static-1.16638",
  "reference-resolvers-lite": "static-1.8107",
  "sales-checkout-service-client": "static-1.3653",
  "ui-addon-iframeable": "static-1.9070",
  "user-context": "static-1.5118",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4660",
  "icons": "static-2.648",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.724",
  "quartz-head": "static-1.714",
  "quartz-test": "static-1.724",
  "quartz-tracking": "static-1.428",
  "ui-fonts": "static-1.746",
  "usage-tracker-container": "static-1.7348",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9437",
  "data-token-picker": "static-1.16432",
  "FileManagerLib": "static-1.39308",
  "property-translator": "static-1.5413",
  "atom": "static-1.5085",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5929",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5446",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-components": "static-1.4232",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "trellis-assets": "static-1.1987",
  "bend-plugin-foundations-theming": "static-1.2914",
  "foundations-theming-base": "static-1.3416",
  "stylex": "static-1.33",
  "interframe": "static-3.4772",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5772",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.75",
  "chirp-fetch": "static-1.1900",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4489",
  "react-flip-move": "static-1.70",
  "bender-build-tools": "static-1.3213",
  "inbound-db-properties-service-client": "static-1.3854",
  "superstore": "static-1.4774",
  "feedback-loader": "static-1.29319",
  "ai-components-ui-library": "static-1.9021",
  "ui-addon-video-player": "static-1.8715",
  "ui-coaching-tips": "static-1.28608",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4627",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2509",
  "magpie-lib": "static-1.5560",
  "navigation-messaging": "static-1.7409",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8183",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4664",
  "content-media-composition-data-lib": "static-1.12372",
  "content-media-compositions": "static-2.16379",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4167",
  "magpie-types": "static-1.5020",
  "media-bridge-lib": "static-1.18951",
  "video-data-lib": "static-1.34986",
  "commerce-products-lib": "static-1.9626",
  "crm-message-bus": "static-1.43039",
  "growth-data-modal": "static-1.5449",
  "hubspot-apollo-client": "static-1.4892",
  "onboarding-tours-client": "static-1.4852",
  "calling-global-api": "static-1.64565",
  "calling-internal-common": "static-1.31315",
  "calling-lifecycle-internal": "static-1.65947",
  "calling-lifecycle-messages": "static-1.58241",
  "conditional-properties-service-client": "static-1.3805",
  "crm-links": "static-1.6306",
  "customer-data-objects-ui-components": "static-1.13040",
  "customer-data-properties-shared-msw-handlers": "static-1.9326",
  "customer-data-property-utils": "static-1.8103",
  "external-options-client-types": "static-1.4167",
  "file-manager-components": "static-1.23668",
  "framework-data-schema-resolvers": "static-1.6897",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.165",
  "inbound-db-meta-service-client": "static-1.3594",
  "inbounddb-objects-service-types": "static-1.4231",
  "meetings-icalendar-utils-lib": "static-1.644",
  "multi-currency-client-types": "static-1.3699",
  "object-builder-ui-client": "static-1.48800",
  "pipeline-validation-client-types": "static-1.3973",
  "property-value-citations": "static-1.2220",
  "pulse": "static-1.587",
  "smart-property-lib": "static-1.7150",
  "tiered-pricing": "static-1.1250",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11002",
  "growth-onboarding-confetti": "static-1.3079",
  "growth-onboarding-next-action-utils": "static-1.1969",
  "navigation-components": "static-1.18082",
  "onboarding-tours-utils": "static-1.704",
  "ui-shepherd-tracker": "static-1.7558",
  "ui-universal-auth": "static-1.8993",
  "batch-promise": "static-1.1554",
  "getting-started-shared-tasks-store": "static-1.17625",
  "hubspotter-http-shared-msw-handlers": "static-1.9997",
  "usage-tracker-session-replay": "static-1.5044",
  "audio-components": "static-1.5934",
  "FileManagerCore": "static-1.39167",
  "FileManagerImages": "static-1.36819",
  "video-components": "static-1.13331",
  "foundations-components-legacy": "static-1.988",
  "purchase-motions-api": "static-1.5932",
  "signup-constants": "static-1.18865",
  "signup-ui-url-generator": "static-2.8064",
  "trials-service-types": "static-1.3915",
  "usage-tracker-public": "static-1.7169",
  "chatspot-core": "static-1.21399",
  "ContentUtils": "static-1.68414",
  "copilot-toolkit": "static-1.11174",
  "growth-onboarding-feedback-components": "static-1.6593",
  "reactive-lib": "static-1.737",
  "simple-logging-lib": "static-1.3063",
  "commerce-permissions": "static-1.782",
  "customer-data-tracking": "static-1.6902",
  "products-iframe-lib": "static-1.7983",
  "products-ui-components-shared-msw-handlers": "static-1.10381",
  "restore-request-side-panel-lib": "static-1.920",
  "onboarding-data-sync-lib": "static-1.1978",
  "hubspot-apollo-cache": "static-1.351",
  "calling-error-reporting": "static-1.31322",
  "shared-worker-versioning": "static-1.11049",
  "calling-usage-tracker": "static-1.6554",
  "self-service-api": "static-1.10260",
  "voice-sms-access-library": "static-1.1027",
  "conversations-skeleton-state": "static-1.7259",
  "location-customization-utils-lib": "static-1.9311",
  "crm-pipelines-api-client-types": "static-1.4147",
  "fdsr-migration-layer": "static-1.16",
  "framework-builder-read-service-client": "static-1.4013",
  "framework-data-schema-quick-fetch": "static-1.6802",
  "persist-promise": "static-1.3711",
  "bend-plugin-pulse": "static-1.90",
  "directed-graph": "static-1.948",
  "event-emitter": "static-1.960",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.215",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10082",
  "fsm": "static-1.3743",
  "policy-lib": "static-1.6790",
  "react-tinymce": "static-1.55290",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10145",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54416",
  "tinymce-plugins": "static-1.57530",
  "tinymce-themes": "static-1.56386",
  "growth-onboarding-next-action-components": "static-1.1997",
  "user-context-client": "static-1.4625",
  "nest": "static-1.240",
  "unified-auth-core-lib": "static-1.789",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4549",
  "video-embed": "static-1.35820",
  "content-icons-ui": "static-1.2229",
  "social-insights-client-types": "static-1.22163",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4825",
  "integrations-lib": "static-1.16201",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4271",
  "InboxConnectUtils": "static-4.14860",
  "meetings-connect-utils-lib": "static-1.7618",
  "calling-orchestration-schema": "static-1.35804",
  "crm-record-cards-service-types": "static-1.3605",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4528",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3055",
  "tinymce-data": "static-1.40501",
  "ui-addon-sales-email": "static-1.5223",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12471",
  "layout-dnd-utils": "static-1.11446",
  "react-codemirror": "static-1.10639",
  "ui-brand-identity-lib": "static-1.15337",
  "NamespacedHubStyle": "static-2.9067",
  "outpost": "static-1.4194",
  "flux-actions": "static-1.338",
  "integrations-error-boundary-lib": "static-1.13616",
  "integrations-tracking-lib": "static-1.5613",
  "native-integrations-shared-strings": "static-1.7794",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10378",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.507",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68489",
  "layout-data-lib": "static-1.9771",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3025",
  "google-sheets-integration-lib": "static-1.289",
  "microsoft-drive-integration-lib": "static-1.414",
  "slack-ui-library": "static-1.10405",
  "advanced-menus-core": "static-1.15148",
  "advanced-menus-lib": "static-1.12087",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34094",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15147",
  "simple-menus-lib": "static-1.16664"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2350",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9681",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25429",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5604",
  "hs-test-utils": "/hs-test-utils/static-1.8026",
  "hub-http": "/hub-http/static-1.6234",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9999",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18275",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11484",
  "I18n": "/I18n/static-7.1628",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6477",
  "payment-link-components": "/payment-link-components/static-1.23588",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7049",
  "quartz-core": "/quartz-core/static-1.6268",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10219",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5353",
  "rich-text-lib": "/rich-text-lib/static-1.19858",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18014",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5621",
  "UIComponents": "/UIComponents/static-3.8430",
  "foundations-assets": "/foundations-assets/static-1.4879",
  "foundations-components": "/foundations-components/static-1.7963",
  "foundations-theming": "/foundations-theming/static-1.4431",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2147",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.911",
  "quartz-config": "/quartz-config/static-1.827",
  "quartz-routing": "/quartz-routing/static-1.479",
  "quick-fetch": "/quick-fetch/static-1.3925",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16684",
  "rpc-client-utils": "/rpc-client-utils/static-1.4665",
  "sanitize-text": "/sanitize-text/static-1.8154",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4775",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9554",
  "usage-tracker": "/usage-tracker/static-1.7358",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5775",
  "usage-tracker-core": "/usage-tracker-core/static-1.7208",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3407",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3326",
  "quartz-webpack": "/quartz-webpack/static-1.3273",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.127",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7682",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7940",
  "laboratory-lib": "/laboratory-lib/static-3.7168",
  "onboarding-scopes": "/onboarding-scopes/static-1.6474",
  "seat-types-lib": "/seat-types-lib/static-1.47",
  "ui-addon-opt": "/ui-addon-opt/static-4.8379",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3137",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.89",
  "ts-schema": "/ts-schema/static-1.4088",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7772",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9839",
  "HubStyle": "/HubStyle/static-2.11791",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.724",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9900",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11161",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9067",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10177",
  "video-components-external": "/video-components-external/static-1.11328",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4340",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6128",
  "customer-data-properties": "/customer-data-properties/static-1.51606",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18507",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5095",
  "onboarding-tours": "/onboarding-tours/static-1.16638",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8107",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3653",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9070",
  "user-context": "/user-context/static-1.5118",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4660",
  "icons": "/icons/static-2.648",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.724",
  "quartz-head": "/quartz-head/static-1.714",
  "quartz-test": "/quartz-test/static-1.724",
  "quartz-tracking": "/quartz-tracking/static-1.428",
  "ui-fonts": "/ui-fonts/static-1.746",
  "usage-tracker-container": "/usage-tracker-container/static-1.7348",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9437",
  "data-token-picker": "/data-token-picker/static-1.16432",
  "FileManagerLib": "/FileManagerLib/static-1.39308",
  "property-translator": "/property-translator/static-1.5413",
  "atom": "/atom/static-1.5085",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5929",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5446",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4232",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "trellis-assets": "/trellis-assets/static-1.1987",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2914",
  "foundations-theming-base": "/foundations-theming-base/static-1.3416",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4772",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5772",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.75",
  "chirp-fetch": "/chirp-fetch/static-1.1900",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4489",
  "react-flip-move": "/react-flip-move/static-1.70",
  "bender-build-tools": "/bender-build-tools/static-1.3213",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3854",
  "superstore": "/superstore/static-1.4774",
  "feedback-loader": "/feedback-loader/static-1.29319",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9021",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8715",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28608",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4627",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2509",
  "magpie-lib": "/magpie-lib/static-1.5560",
  "navigation-messaging": "/navigation-messaging/static-1.7409",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8183",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4664",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12372",
  "content-media-compositions": "/content-media-compositions/static-2.16379",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4167",
  "magpie-types": "/magpie-types/static-1.5020",
  "media-bridge-lib": "/media-bridge-lib/static-1.18951",
  "video-data-lib": "/video-data-lib/static-1.34986",
  "commerce-products-lib": "/commerce-products-lib/static-1.9626",
  "crm-message-bus": "/crm-message-bus/static-1.43039",
  "growth-data-modal": "/growth-data-modal/static-1.5449",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4892",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4852",
  "calling-global-api": "/calling-global-api/static-1.64565",
  "calling-internal-common": "/calling-internal-common/static-1.31315",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65947",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58241",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3805",
  "crm-links": "/crm-links/static-1.6306",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13040",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9326",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8103",
  "external-options-client-types": "/external-options-client-types/static-1.4167",
  "file-manager-components": "/file-manager-components/static-1.23668",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6897",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.165",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3594",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4231",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.644",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3699",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48800",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3973",
  "property-value-citations": "/property-value-citations/static-1.2220",
  "pulse": "/pulse/static-1.587",
  "smart-property-lib": "/smart-property-lib/static-1.7150",
  "tiered-pricing": "/tiered-pricing/static-1.1250",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11002",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3079",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1969",
  "navigation-components": "/navigation-components/static-1.18082",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.704",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7558",
  "ui-universal-auth": "/ui-universal-auth/static-1.8993",
  "batch-promise": "/batch-promise/static-1.1554",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17625",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9997",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5044",
  "audio-components": "/audio-components/static-1.5934",
  "FileManagerCore": "/FileManagerCore/static-1.39167",
  "FileManagerImages": "/FileManagerImages/static-1.36819",
  "video-components": "/video-components/static-1.13331",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.988",
  "purchase-motions-api": "/purchase-motions-api/static-1.5932",
  "signup-constants": "/signup-constants/static-1.18865",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8064",
  "trials-service-types": "/trials-service-types/static-1.3915",
  "usage-tracker-public": "/usage-tracker-public/static-1.7169",
  "chatspot-core": "/chatspot-core/static-1.21399",
  "ContentUtils": "/ContentUtils/static-1.68414",
  "copilot-toolkit": "/copilot-toolkit/static-1.11174",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6593",
  "reactive-lib": "/reactive-lib/static-1.737",
  "simple-logging-lib": "/simple-logging-lib/static-1.3063",
  "commerce-permissions": "/commerce-permissions/static-1.782",
  "customer-data-tracking": "/customer-data-tracking/static-1.6902",
  "products-iframe-lib": "/products-iframe-lib/static-1.7983",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10381",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.920",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1978",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.351",
  "calling-error-reporting": "/calling-error-reporting/static-1.31322",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11049",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6554",
  "self-service-api": "/self-service-api/static-1.10260",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1027",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7259",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9311",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4147",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.16",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4013",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6802",
  "persist-promise": "/persist-promise/static-1.3711",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.90",
  "directed-graph": "/directed-graph/static-1.948",
  "event-emitter": "/event-emitter/static-1.960",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.215",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10082",
  "fsm": "/fsm/static-1.3743",
  "policy-lib": "/policy-lib/static-1.6790",
  "react-tinymce": "/react-tinymce/static-1.55290",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10145",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54416",
  "tinymce-plugins": "/tinymce-plugins/static-1.57530",
  "tinymce-themes": "/tinymce-themes/static-1.56386",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1997",
  "user-context-client": "/user-context-client/static-1.4625",
  "nest": "/nest/static-1.240",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.789",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4549",
  "video-embed": "/video-embed/static-1.35820",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "social-insights-client-types": "/social-insights-client-types/static-1.22163",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4825",
  "integrations-lib": "/integrations-lib/static-1.16201",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4271",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14860",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7618",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35804",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3605",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4528",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3055",
  "tinymce-data": "/tinymce-data/static-1.40501",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5223",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12471",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11446",
  "react-codemirror": "/react-codemirror/static-1.10639",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15337",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9067",
  "outpost": "/outpost/static-1.4194",
  "flux-actions": "/flux-actions/static-1.338",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13616",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5613",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7794",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10378",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.507",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68489",
  "layout-data-lib": "/layout-data-lib/static-1.9771",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3025",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.289",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.414",
  "slack-ui-library": "/slack-ui-library/static-1.10405",
  "advanced-menus-core": "/advanced-menus-core/static-1.15148",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12087",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34094",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15147",
  "simple-menus-lib": "/simple-menus-lib/static-1.16664"
}
};
